import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

// Auth
export const loginAdmin = async (email, password) => {
  const response = await axios.post(`${API}/auth/login`, { email, password });
  return response.data;
};

// Produtos
export const listarProdutos = async (categoria = null) => {
  const params = categoria ? { categoria } : {};
  const response = await axios.get(`${API}/produtos`, { params });
  return response.data;
};

export const criarProduto = async (produto, token) => {
  const response = await axios.post(`${API}/produtos`, produto, {
    headers: { Authorization: `Bearer ${token}` }
  });
  return response.data;
};

export const atualizarProduto = async (id, produto, token) => {
  const response = await axios.put(`${API}/produtos/${id}`, produto, {
    headers: { Authorization: `Bearer ${token}` }
  });
  return response.data;
};

export const deletarProduto = async (id, token) => {
  const response = await axios.delete(`${API}/produtos/${id}`, {
    headers: { Authorization: `Bearer ${token}` }
  });
  return response.data;
};

// Feedbacks
export const listarFeedbacks = async (apenasAprovados = true) => {
  const response = await axios.get(`${API}/feedbacks`, {
    params: { apenas_aprovados: apenasAprovados }
  });
  return response.data;
};

export const criarFeedback = async (feedback) => {
  const response = await axios.post(`${API}/feedbacks`, feedback);
  return response.data;
};

export const aprovarFeedback = async (id, token) => {
  const response = await axios.patch(`${API}/feedbacks/${id}/aprovar`, {}, {
    headers: { Authorization: `Bearer ${token}` }
  });
  return response.data;
};

export const deletarFeedback = async (id, token) => {
  const response = await axios.delete(`${API}/feedbacks/${id}`, {
    headers: { Authorization: `Bearer ${token}` }
  });
  return response.data;
};

// Galeria
export const listarTrabalhos = async (categoria = null) => {
  const params = categoria ? { categoria } : {};
  const response = await axios.get(`${API}/galeria`, { params });
  return response.data;
};

export const criarTrabalho = async (trabalho, token) => {
  const response = await axios.post(`${API}/galeria`, trabalho, {
    headers: { Authorization: `Bearer ${token}` }
  });
  return response.data;
};

export const deletarTrabalho = async (id, token) => {
  const response = await axios.delete(`${API}/galeria/${id}`, {
    headers: { Authorization: `Bearer ${token}` }
  });
  return response.data;
};

// Upload
export const uploadImagem = async (file, token) => {
  const formData = new FormData();
  formData.append('file', file);
  
  const response = await axios.post(`${API}/upload/imagem`, formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
      Authorization: `Bearer ${token}`
    }
  });
  return response.data;
};
